import gql from 'graphql-tag';

const NAME = 'moveIqAddress';
const FRAGMENT = `fragment ${NAME} on MoveIqAddress {
  street
  unit
  city
  state
  postalCode
}`;

export default {
  fragment: FRAGMENT,
  name: NAME,
  gql: gql`
    ${FRAGMENT}
  `,
};
